import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'react-final-form';
import { Button, Modal } from 'antd';

import { i18 } from '../../../utilities';
import { FormField, formFieldType, Translate } from '../../../components';
import { servicesActions, servicesConstants } from '../../../api';

class CoefficientsForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };

        this.toggle = this.toggle.bind(this);
        this.submit = this.submit.bind(this);
        this.checkCoefficient = this.checkCoefficient.bind(this);
    }

    toggle(state) {
        this.setState({ visible: state });
    }

    submit(values) {
        this.props
            .dispatch(
                servicesActions.putCoefficients({
                    apartmentPriceCoefficient: values?.apartmentPriceCoefficient ?? null,
                    administratorPriceCoefficient: values?.administratorPriceCoefficient ?? null
                })
            )
            .then(res => {
                if (res && res.type === servicesConstants.PUT_COEFFICIENTS_SUCCESS) {
                    this.toggle();
                }
            });
    }

    checkCoefficient({ floatValue, formattedValue }) {
        if (formattedValue === '') {
            return true;
        }

        return floatValue >= 0 && floatValue <= 1;
    }

    render() {
        return (
            <>
                <Button type="primary" onClick={() => this.toggle(true)}>
                    <Translate value={i18.CoefficientsForm.Buttons.Add} />
                </Button>
                <Modal
                    title={<Translate value={i18.CoefficientsForm.Titles.Add} />}
                    visible={this.state.visible}
                    onCancel={() => this.toggle(false)}
                    footer={null}
                    maskClosable={false}
                >
                    <Form
                        onSubmit={this.submit}
                        render={({ handleSubmit, values }) => (
                            <form onSubmit={handleSubmit} autoComplete="off">
                                <FormField
                                    component={formFieldType.number}
                                    title={i18.CoefficientsForm.Labels.ApartmentCoefficient}
                                    name="apartmentPriceCoefficient"
                                    isAllowed={this.checkCoefficient}
                                />
                                <FormField
                                    component={formFieldType.number}
                                    title={i18.CoefficientsForm.Labels.AdministrationtCoefficient}
                                    name="administratorPriceCoefficient"
                                    isAllowed={this.checkCoefficient}
                                />
                                <div className="text-right">
                                    <Button type="primary" htmlType="submit">
                                        <Translate value={i18.CoefficientsForm.Buttons.Submit} />
                                    </Button>
                                </div>
                            </form>
                        )}
                    />
                </Modal>
            </>
        );
    }
}

CoefficientsForm.propTypes = {
    dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {}

const connectedSCoefficientsForm = connect(mapStateToProps)(CoefficientsForm);
export { connectedSCoefficientsForm as CoefficientsForm };
